var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarbonNeutral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 0.987069C7.33333 0.78083 7.14743 0.623263 6.94843 0.677414C6.45631 0.811324 5.9843 1.04103 5.56116 1.36652L4.44949 2.22165L6.81026 3.85603C7.03134 4.00908 7.33333 3.85085 7.33333 3.58196V0.987069Z",
    fill: "#1D964F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33355 6.009C7.33341 5.89966 7.27966 5.79733 7.1897 5.73518L3.33992 3.07516L1.71265 4.32691L6.81242 7.85752C7.03365 8.01068 7.33582 7.85212 7.33549 7.58304L7.33355 6.009Z",
    fill: "#1D964F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18696 7.85796C8.96572 8.01112 8.66418 7.85219 8.66452 7.58311C8.66528 6.96575 8.66608 6.31211 8.66645 6.00838C8.66659 5.89904 8.72034 5.79733 8.8103 5.73518L12.6601 3.07516L14.2874 4.32691C14.2874 4.32691 11.3639 6.35081 9.18696 7.85796Z",
    fill: "#1D964F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18974 3.85603C8.96866 4.00908 8.66667 3.85085 8.66667 3.58196V0.987068C8.66667 0.780829 8.85257 0.623262 9.05157 0.677413C9.54369 0.811323 10.0157 1.04103 10.4388 1.36652L11.5505 2.22165L9.18974 3.85603Z",
    fill: "#1D964F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4074 5.17315L9.13842 9.51324C8.45353 9.98739 7.54647 9.98739 6.86158 9.51324L0.592565 5.17315C0.230337 5.44507 0 5.85163 0 6.3053V14.009C0 14.8262 0.747333 15.4905 1.66667 15.4905L14.3333 15.4905C15.2527 15.4905 16 14.8262 16 14.009V6.3053C16 5.85163 15.7697 5.44507 15.4074 5.17315ZM1.33334 12.8208L1.33334 7.54177L4.87742 9.99537L1.33334 12.8208ZM14.6667 7.54177L11.1226 9.99537L14.6667 12.8208L14.6667 7.54177ZM6.48211 11.1063L6.00423 10.7755L1.71935 14.1913L14.2807 14.1913L9.99579 10.7755L9.5179 11.1063C8.60471 11.7385 7.3953 11.7385 6.48211 11.1063Z",
    fill: "#1D964F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonNeutral);
export default __webpack_public_path__ + "static/media/carbon-neutral.33767e3f2dd6668dc92e33d8fb81380a.svg";
export { ForwardRef as ReactComponent };